export default {
  'title': 'Nos points de retrait',
  'sub-title': 'Découvrez nos magasins à Paris et en Île de France.',
  'pickup-hours': 'Retrait de 9h à 14h et de 15h à 21h 6j/7',
  'select-button': 'Choisir ce point de retrait',
  'no-pickup-zones': "Il n'y a aucun point de retrait dans votre zone :(",
};
